module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_epopcon_m.949de46e5f97d44fb23b9187484320d9.png";